import { createQueryHook } from '../../createQueryHook'
import { FormConfiguration } from '../../types'

export default createQueryHook<undefined, FormConfiguration>({
  getKey: () => ['app/forms-configuration/fields-configurations?formName=ApplicationForm'],
  getEndpoint: () => 'app/forms-configuration/fields-configurations?formName=ApplicationForm'
})
